import { useState, useEffect } from 'react';
import { WhatIfReport } from '../components/toplist/human/modals/WhatIfModal';

export interface PortfolioResult {
  deposit_register_id: number;
  invested_amount_eur: number;
  current_value_usd: number;
  current_value_eur: number;
  pnl_percent: number;
  strategy: string;
  status: string;
  error_message: string;
  invested_amount_usd: number;
  btc_quantity: number;
  eth_quantity: number;
  total_payouts_eur: number;
  
  // --- ÚJ MEZŐK A FRONTEND KALKULÁTORHOZ ---
  total_liquidity_usd: number;
  total_mining_usd: number;
  total_altcoin_vault_usd: number;
  btc_live_price: number;
  eth_live_price: number;

  // --- ÚJ PROTO MEZŐK ---
  bonus_eur: number;
  capital_ratio_eur: number;

  what_if?: WhatIfReport;
}

export function usePortfolioStream(ids: number[]) {
  const [topList, setTopList] = useState<PortfolioResult[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (!ids || ids.length === 0) return;

    setLoading(true);
    setTopList([]);

    const url = `${process.env.REACT_APP_SAPI_URL}/stream-toplist?ids=${ids.join(',')}`;
    
    if (typeof window === 'undefined' || !window.EventSource) {
      console.error('Az EventSource nem támogatott ebben a környezetben.');
      setLoading(false);
      return;
    }

    const eventSource = new window.EventSource(url);

    eventSource.onmessage = (event: MessageEvent) => {
      try {
        const newPortfolio: PortfolioResult = JSON.parse(event.data);

        setTopList((prevList) => {
          const filtered = prevList.filter(
            (item) => item.deposit_register_id !== newPortfolio.deposit_register_id
          );
          // Csak simán összefűzzük az elemeket, a sorba rendezést átrakjuk a komponensbe,
          // mert a What-If kalkulátor fiktív százalékai alapján kell majd rendezni!
          return [...filtered, newPortfolio];
        });
      } catch (err) {
        console.error('[SSE] JSON parsolási hiba a kliensen:', err);
      }
    };

    eventSource.addEventListener('end', () => {
      console.log('[SSE] Kész, lezárjuk a kapcsolatot.');
      eventSource.close();
      setLoading(false);
    });

    eventSource.onerror = (err: any) => {
      console.error('[SSE Hiba]:', err);
      eventSource.close();
      setLoading(false);
    };

    return () => {
      eventSource.close();
    };
  }, [ids]);

  return { topList, loading };
}